function Status({ text, className, bg = 'bg-tagGrayBg' }) {
    return (
        <p
            className={` capitalize font-semibold text-xs px-3 py-2 ${bg} text-tagGrayText rounded-3xl border  border-borderBtn  ${className}`}
        >
            {text}
        </p>
    );
}

export default Status;
